// extracted by mini-css-extract-plugin
export default {"root":"hero-screen_root__yjqMO","bg":"hero-screen_bg__kKrWq","motto":"hero-screen_motto__sFJsk","subheading":"hero-screen_subheading__cQVWc"};